import React, { ReactElement } from 'react';
import ReactDOM from 'react-dom';
import Routes from './routes';
import 'index.css';
import 'react-toastify/dist/ReactToastify.css';
import * as serviceWorker from './serviceWorker';
import { HelmetProvider } from 'react-helmet-async';
import { ToastContainer } from 'react-toastify';

const MOUNT_NODE = document.getElementById('root') as HTMLElement;

interface Props {
  AppRouter: typeof Routes;
}

const ConnectedApp = ({ AppRouter }: Props): ReactElement => (
  <HelmetProvider>
    <React.StrictMode>
      <AppRouter />
      <ToastContainer />
    </React.StrictMode>
  </HelmetProvider>
);

ReactDOM.render(<ConnectedApp AppRouter={Routes} />, MOUNT_NODE);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
